import * as React from 'react';
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";

// Components
import {
  Homepage,
  TestEditor,
  LearningPage
} from "./index";

class App extends React.Component {
  constructor(props:any) {
    super(props);
    this.state = {};

  }

  public render() {
    return (
      <div className="App">
        <Switch>
          <Route exact path="/test-editor/:language" component={TestEditor} />
          <Route exact path="/learning-page/:course_id" component={LearningPage} />
          <Route path="/" component={Homepage} />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state:any) => {
  return {
    ...state,
  }
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App.tsx